import React from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { BarElement, CategoryScale, Chart as ChartJS, LinearScale, Tooltip } from "chart.js";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import { InsightsCard } from "./InsightsCard";
import { INSIGHTS_COLORS, TOOLTIP_STYLE, niceScale, truncateLabel } from "./colors";
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip);
/** Cards 2 and 3: devices per category as thin blue-gradient bars (a device with several categories counts in each). */
export const CategoryBarCard = ({ title, icon, info, data, loading, error, emptyText, labelChars = 10, }) => {
    const { t } = useTranslation(["common"]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const rows = data !== null && data !== void 0 ? data : [];
    const scale = niceScale(rows.map((r) => r.count));
    const maxChars = isMobile ? Math.max(4, labelChars - 4) : labelChars;
    const chartData = {
        labels: rows.map((r) => r.name),
        datasets: [
            {
                label: t("common:catalog.insights.devices", "Devices"),
                data: rows.map((r) => r.count),
                backgroundColor: (context) => {
                    const { chart } = context;
                    const area = chart.chartArea;
                    if (!area)
                        return INSIGHTS_COLORS.barTop;
                    const gradient = chart.ctx.createLinearGradient(0, area.top, 0, area.bottom);
                    gradient.addColorStop(0, INSIGHTS_COLORS.barTop);
                    gradient.addColorStop(1, INSIGHTS_COLORS.barBottom);
                    return gradient;
                },
                borderRadius: 8,
                borderSkipped: false,
                barThickness: isMobile ? 10 : 14,
            },
        ],
    };
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            tooltip: Object.assign(Object.assign({}, TOOLTIP_STYLE), { displayColors: false }),
        },
        scales: {
            x: {
                grid: { display: false },
                border: { display: false },
                ticks: {
                    color: INSIGHTS_COLORS.tick,
                    font: { size: isMobile ? 10 : 12 },
                    autoSkip: false,
                    maxRotation: 0,
                    callback: (_, index) => { var _a, _b; return truncateLabel((_b = (_a = rows[index]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "", maxChars); },
                },
            },
            y: {
                min: 0,
                max: scale.max,
                border: { display: false },
                grid: { color: INSIGHTS_COLORS.grid, tickBorderDash: [4, 4], borderDash: [4, 4] },
                ticks: { color: INSIGHTS_COLORS.tick, stepSize: scale.stepSize, padding: 8, font: { size: 12 } },
            },
        },
    };
    return (React.createElement(InsightsCard, { title: title, icon: icon, info: info, loading: loading, error: error, height: 320, emptyText: !loading && !error && rows.length === 0 ? emptyText : null },
        React.createElement(Bar, { data: chartData, options: options })));
};
